import { TranslateService } from "@ngx-translate/core";
import { MenuContainerBaseComponent } from "./../../../../common-theme/base-components/shared/menu/menu-container-base/menu-container-base.component";
import {
  Component,
  Inject,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { AgencyService } from "../../../../common-theme/api/agency.service";
import { DOCUMENT } from "@angular/platform-browser";
// import { CookieHeightChangeService } from '../../../../common-theme/utils/cookie/cookie-height-change.service';
import { LocaleService } from "../../../../common-theme/index";

@Component({
  selector: "app-menu-container",
  templateUrl: "./menu-container.component.html",
  styleUrls: [
    "./menu-container.component.scss",
    "../../../../common-theme/base-components/shared/menu/menu-container-base/menu-container-base.component.scss",
  ],
})
export class MenuContainerComponent extends MenuContainerBaseComponent
  implements AfterViewInit {
  @ViewChild("menu") menu: ElementRef;
  public marginTop: number = 0;

  constructor(
    public agencyService: AgencyService,
    public localeService: LocaleService,
    @Inject(DOCUMENT) public document: any,
    public translate: TranslateService // private cookieHeightChangeService: CookieHeightChangeService
  ) {
    super(agencyService, document);
  }

  ngAfterViewInit(): void {
    // this.cookieHeightChangeService.emitter.subscribe(height => this.menu.nativeElement.style.marginTop = height + 'px');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/menu/menu-container/menu-container.component.ts